export interface ProcessType{
    id: number
    name: string
}

export enum ProcessPayState{
    Open = "OPEN",
    Paid = "PAID",
    PartlyPaid = "PARTLY_PAID",
}

export interface IProcessBase{
    id: number
    number: string
    amount: number
    amountPaid: number
    amountOpen: number
    date: Date
    canceled: boolean
    type: ProcessType
}

export class ProcessBase implements IProcessBase {
    public id: number;
    public number: string;
    public amount: number;
    public amountPaid: number
    public amountOpen: number
    public canceled: boolean
    public date: Date;
    public type: ProcessType

    public get payState(): ProcessPayState {
        if (this.amountOpen <= 0) return ProcessPayState.Paid;
        if (this.amountPaid > 0 && this.amountOpen > 0) return ProcessPayState.PartlyPaid;
        return ProcessPayState.Open;
    }

    constructor(data: IProcessBase) {
        this.id = data?.id || 0;
        this.number = data?.number || '';
        this.amount = data?.amount || 0;
        this.amountPaid = data?.amountPaid || 0;
        this.amountOpen = data?.amountOpen || 0;
        this.date = data?.date || new Date();
        this.canceled = data?.canceled || false;
        this.type = data?.type || { id: -1, name: '' };
    }
}

export interface ProcessPositionArt{
    id: number
    description?: string
}

export interface ProcessPosition{
    id: number
    position: string
    description: string
    positionText: string
    price: number
    amount: number
    priceTotal: number
    art: ProcessPositionArt
}